import React, { useEffect, useState } from 'react'
import Dashboard from '../Dashboard/Dashboard'
import { useNavigate, useParams } from "react-router-dom";

import { styled } from '@mui/material/styles';

import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Delete } from '@mui/icons-material';

const Rights = () => {
  let { username } = useParams();
  const [empname, setempname] = useState("")
  const [permissionsList,setpermissionsList]=useState([]);
  const [edit,setedit]=useState(false);
  const [delete2,setdelete2]=useState(false)
  useEffect(()=>{
    const getEmpdata=async ()=>{
      try{
        let id=username;
        let tableName="employees_data"
        const url=`https://policydekhoo-backend.onrender.com/Getpermission?tableName=${tableName}&id=${id}`
        let response=await fetch(url,{
          method:"GET",
          headers:{"Content-Type":"apllication/json"}
        })
        .then((response=>response.json()))
        if(response.msg!=="Records Not found")
          {
            const data=response.Permissions
            if(data!==null)
              {
              
            setpermissionsList(data.split(","))
            
              }
         
          }
          else{
            console.log("data doesn't exist..!");
          }
      }
      catch(error){
        console.log(error);
      }
    }
    getEmpdata()
  },[])
  const rows = [
    ['Aman Gahlot', '96356363633', "aman@12.com", "AMAN_.12", "xxxxxx"],
    ['Jai Raj Chouhan  ', '96356363633', "jai@12.com", "JAI_.12", "xxxxxx"],
    ['Rohin Singh Rawat', '96356363633', "rohan@12.com", "ROHAN_.12", "xxxxxx"],
    ['Employee4', '96356363633', "emp4@12.com", "EMP4_.12", "xxxxxx"],
    ['Employee5', '96356363633', "emp5@12.com", "EMP5_.12", "xxxxxx"],
    ['Aman Gahlot', '96356363633', "aman@12.com", "AMAN_.12", "xxxxxx"],
    ['Aman Gahlot', '96356363633', "aman@12.com", "AMAN_.12", "xxxxxx"],
    ['Jai Raj Chouhan  ', '96356363633', "jai@12.com", "JAI_.12", "xxxxxx"],
    ['Rohin Singh Rawat', '96356363633', "rohan@12.com", "ROHAN_.12", "xxxxxx"],
    ['Employee4', '96356363633', "emp4@12.com", "EMP4_.12", "xxxxxx"],
    ['Employee5', '96356363633', "emp5@12.com", "EMP5_.12", "xxxxxx"],
    ['Aman Gahlot', '96356363633', "aman@12.com", "AMAN_.12", "xxxxxx"],

  ];
  useEffect(() => {

    rows.map((val, index) => {
      if (val[3] === username) {
        setempname(val[0])
      }
    })
  }, [empname])
  const [permissionData, setpermissionData] = useState({
    
    Edit:false,
    Delete:false
  })
  useEffect(()=>{
    let tempPer={...permissionData}
    permissionsList.map((permissions)=>{
    if(permissions=="edit")
      {
        console.log("edit")
        tempPer.Edit=true
        
      }
      if(permissions=="delete")
        {
          console.log("log");
          tempPer.Delete=true
         
        }
      })
      setpermissionData(tempPer)
        
  },[permissionsList])



  const permissions = [

    "Edit",
    "Delete",
  ]
  
 

  const addValues = (e, permission) => {
    setpermissionData({ ...permissionData, [e.target.name]: !permissionData[permission] })
  }
  console.log(permissionData);
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    border: 2,
    height: 16,
    margin: 0,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : "#212A3E",
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));
  const role = JSON.parse(localStorage.getItem("userData")).Roles;

  const [tableName, settablename] = useState("employees_data");


  const handleSubmit2 = async (id, e) => {
    // e.preventDefault();
    let permission
    if (permissionData.Edit === true && permissionData.Delete === true) {
      permission = "view,edit,delete"
    }
    else if (permissionData.Edit === true) {
      permission = "view,edit"
    }
    else if (permissionData.Delete === true) {
      permission = "view,delete"
    }
    else {
      permission = "view"
    }
    console.log(permission, "permissionnnnnnn");

    let data2 = {
      Permissions: `${permission}`
    }


    try {
      const response = await fetch(
        `https://policydekhoo-backend.onrender.com/Updatedata?tableName=${tableName}&id=${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data2),
        }
      );

      if (response.ok) {
        // props.dataUpdate(data2, id)
        console.log("Data updated successfully");
        // props.handleClose()
      } else {
        console.error("Failed to update data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <Dashboard name={"employee"} heading={"Employee List"} />

      <div className={role == "Admin" ? 'main-div' : "main-div2"}>
        <div className='row justify-content-center my-3 align-items-center fs-4' >{empname}</div>
        <div className="row my-4 mx-2 text-secondary ">
          <div className="col-1 ms-1">Permissions</div>
          <div className="col ">
            <hr />
          </div>
        </div>

        <div className='m-5'>
          <div className='row m-4 my-3 align-items-center fs-4' >General  </div>
          <div className='row text-center px-5 ' style={{ whiteSpace: 'nowrap' }}>
            {permissions.map((permission, index) => (

              <div className='col col-sm-4 col-md-3  px-2 my-3 text-center'>
                <Stack direction="row" spacing={1} alignItems="center">
                  <AntSwitch onChange={(e) => { addValues(e, permission) }} name={permission} checked={permissionData[permission] ? true : false} inputProps={{ 'aria-label': 'ant design' }} />
                  <Typography><label htmlFor="std" >{permission}</label></Typography>
                </Stack>
              </div>
            ))}
          </div>


          {/* <div className='row m-4 mt-5 mb-3 align-items-center fs-4' >Some Rights</div>
          <div className='row text-center px-5' style={{whiteSpace: 'nowrap' }}> 
        {permissions.map((permission,index)=>(
            
             <div className=' col col-sm-4 col-md-3 px-2 my-3 text-center'>
          <Stack direction="row" spacing={1} alignItems="center">
             <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
             <Typography><label htmlFor="std" >{permission}</label></Typography>
           </Stack>
       </div>
        ))}
        </div> */}
        </div>






        <div className="row justify-content-center my-5"> <div className="col text-center my-5"><button className="p-1 px-5 text-center px-4 rounded border accepted-bg" onClick={() => {
          handleSubmit2(username)
        }}>Save</button></div></div>
      </div>
    </>
  )
}

export default Rights